module.exports = __webpack_public_path__ + "static/xtz-d8ea496f2a898c4e06e235753849a69e.png";